import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as PlayIcon } from '../assets/logos/play button.svg';
import { ReactComponent as NewIcon } from '../assets/logos/new.svg';
import { ReactComponent as OpenIcon } from '../assets/logos/open.svg';
// import { ReactComponent as PortfolioIcon } from '../assets/logos/my portfolio.svg';
import PortfolioIcon from '../assets/logos/my portfolio.svg';
// import { ReactComponent as LabAssignmentIcon } from '../assets/logos/lab assignment.svg';
import LabAssignmentIcon from '../assets/logos/lab assignment.svg';
import { ReactComponent as QuickTipIcon } from '../assets/logos/quick tip.svg';
// import { ReactComponent as EvaluateIcon } from '../assets/logos/evaluate icon.svg';
import EvaluateIcon from '../assets/logos/evaluate icon.svg';
// import { ReactComponent as ManageMenuIcon } from '../assets/logos/manage menu icon.svg';
import ManageMenuIcon from '../assets/logos/manage menu icon.svg';
import VectorIcon from '../assets/logos/Vector.svg';
import { QuestionCircleOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faCloudSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import {
  Avatar,
  Card,
  List,
  Divider,
  Typography,
  Tour,
  message,
  Col,
  Row,
  Skeleton,
  Tooltip,
  Modal
} from "antd";
import {  global_var, projectCategoryMapping } from "../services/cs-lab-config";
import {
  getIdeProjectLogo,
  getCurrentGreetingMessage,
  getIdeProjectTypeMetaData,
  getShowMyProjectFlag,
  getShowTutorialVideo,
  trackEvent,
} from "./utils/util-functions";
import { getProgrammingTip,loadMenuForCslab ,getPendingEvaluationCount} from "../services/ide-apis";
import { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import tourIDEimg from "../assets/images/tourIDEimg.png";
import tourProjects from "../assets/images/tourProjects.png";
// import { ReactComponent as ChatAiIconBlack } from '../assets/logos/chat-ai-icon-black.svg'
import ChatAiIconBlack from '../assets/logos/chat-ai-icon-black.svg'

const { Meta } = Card;

const Home = () => {
  document.title = "CS Cloud Lab | " + global_var.company_name;

  function setActions(projectStackName, index, topIndex) {
    const actions = [
      <Tooltip title={"New Project"}>
        <NewIcon
          onClick={() => navigateToIde(projectStackName)}
          ref={index === 0 && topIndex === 0 ? goToIdeButton : null}
          key="ide"
          style={{
            color: "mediumblue",
          }}
        />
      </Tooltip>
    ];

    if (!getShowMyProjectFlag(projectStackName)) {
      actions.push(
        <Link
          to={"/projects/" + projectStackName}
          ref={index === 0 && topIndex === 0 ? goToMyProjects : null}
          onClick={() => {
            trackEvent("landing_page_projects_button_clicked", {
              ide_project_stack_name: projectStackName,
            });
          }}
        >
          <Tooltip title={"My Projects"}>
            <OpenIcon
              key="myprojects"
              style={{
                color: "#00bd0b",
              }}
            />
          </Tooltip>
        </Link>
      );
    }

    if (getShowTutorialVideo(projectStackName)) {
      actions.push(
        <Link
          onClick={() => {
            setOpen(true);
            let tutorialVideoUrl = getShowTutorialVideo(projectStackName)
            tutorialVideoUrl = tutorialVideoUrl + '?fs=0&rel=0&modestbranding=0&controls=1&disablekb=1&showinfo=0&iv_load_policy=3&cc_load_policy=0'
            setTutorialVideo(tutorialVideoUrl)
          }}
        >
            <Tooltip title={"Video Tutorial"}>
            <PlayIcon
              key="play"
            />
            </Tooltip>
        </Link>
      );
    }

    return actions;
  }

  const [tip, setTip] = useState("");
  const [pendingEvaluationCount, setPendingEvaluationCount] = useState(0);
  const [submittedAssignmentCount, setSubmittedAssignmentCount] = useState(0);
  const [notStartedAssignmentCount, setNotStartedAssignmentCount] = useState(0);
  const [openTour, setOpenTour] = useState(false);
  const [projectStacks, setProjectStacks] = useState(null);

  const goToIdeButton = useRef(null);
  const goToMyProjects = useRef(null);
  const ref3 = useRef(null);
  const [open, setOpen] = useState(false);
  const [tutorialUrl, setTutorialVideo] = useState('');

  // const userToken = localStorage.getItem("token");
  const userToken = sessionStorage.getItem('token');

  const navigate = useNavigate();

  const handleCancel = () => {
    setOpen(false);
    setTutorialVideo('')
  };

  const steps = [
    {
      title: "IDE",
      description: "Click on this button to navigate to IDE",
      cover: <img alt="ide screen" src={tourIDEimg} />,
      placement: "top",
      target: () => ref3.current,
      className: "glass",
    },
    {
      title: "My Projects",
      description: "Click on this button to see your projects",
      cover: <img alt="my projects screen" src={tourProjects} />,
      placement: "top",
      target: () => ref3.current,
      className: "glass",
    },
  ];
  useEffect(() => {
    loadMenuForCslab().then((response) => {
      response = response.data
      if (response.statusCode === 200) {
        const menuStructure = response.menuStructure;
        const updatedProjectStacks = {};

        menuStructure.forEach(item => {
          const categoryName = item.categoryName;
          const menuName = item.stackName;
          
          if (!updatedProjectStacks[categoryName]) {
            updatedProjectStacks[categoryName] = { sortOrder: projectCategoryMapping[categoryName]['sortOrder'], items:[]};
          }
          
          updatedProjectStacks[categoryName].items.push({ projectStackName: menuName });
        });
        
        // sort start
        let sortedArray = Object.entries(updatedProjectStacks).sort((a, b) => a[1].sortOrder - b[1].sortOrder);
        let sortedObj = {};

        sortedArray.forEach(([key, value]) => {
          sortedObj[key] = value.items;
        });
        if (response.aiSettings) {
          global_var.allowedAiFeatures = response.aiSettings;
        }

        // sort end
        setProjectStacks(sortedObj);

      }
    });
  }, []);

  function navigateToIde(projectStackName) {
    trackEvent("landing_page_ide_button_clicked", {
      ide_project_stack_name: projectStackName,
    });

    const projectMetaData = getIdeProjectTypeMetaData(projectStackName);
    if (projectMetaData.route) {
      if (projectMetaData.openInNewTab) {
        window.open(projectMetaData.route + "?token=" + userToken);
      } else {
        navigate(projectMetaData.route);
      }
    } else {
      message.info("Coming soon.");
    }
  }
  useEffect(() => {
    const isStudent = global_var.role_id === global_var.STUDENT_ROLE_ID;
    const statusFlags = {
      submitted: isStudent ? false : true,
      notStarted: isStudent ? true : false,
      pending: isStudent ? false : true,
    };
    getPendingEvaluationCount(statusFlags).then((res) => {
      const response = res.data;
      if (response.statusCode === 200) {
        setPendingEvaluationCount(response.pendingCount);
        setSubmittedAssignmentCount(response.submittedCount);
        setNotStartedAssignmentCount(response.notStartedCount);
      }
    });
    getProgrammingTip().then((response) => {
      response = response.data;
      if (response.statusCode === 200) {
        setTip(response.text);
      }
    });
  }, []);

  return (
    <>
    {tutorialUrl!== '' && (
      <Modal
        title="Tutorial"
        open={open}
        footer={null}
        onCancel={handleCancel}
        width="100vw" // Makes the modal width responsive,
        style={{ 
          top: 20,
          height: "90vh"
        }} // Adjust the top position of the modal
      >
          <div className="modal-iframe-wrapper">
            <iframe
              id="Tutorial"
              src={tutorialUrl}
              title="Scratch JR"
              allow="camera; microphone"
              frameBorder="0"
              style={{
                width: '100%',
                height: '90vh'
              }}
              allowFullScreen
            ></iframe>
          </div>
      </Modal>
    )}

      <Row className="mt-4">
        <Col className="col-10 px-2">
          {" "}
          <span className="poppins-light text-midgrey" style={{fontSize:'24px'}}>
            <FontAwesomeIcon 
              icon={
                getCurrentGreetingMessage().icon === "sun" ? faSun : 
                getCurrentGreetingMessage().icon === "cloud-sun" ? faCloudSun : 
                faMoon
              } 
              style={{marginRight: '8px', color: 
                getCurrentGreetingMessage().icon === "sun" ? "#FDB813" : 
                getCurrentGreetingMessage().icon === "cloud-sun" ? "#F8D775" : 
                "#6E76B4"
              }} 
            />
            {getCurrentGreetingMessage().greeting},
          </span>
          <span className="poppins-medium" style={{textTransform: 'capitalize',fontSize:'24px'}}> {global_var.user_name || global_var.username || <Skeleton />}</span>
        </Col>
        <Col className="text-end col-2">
          <QuestionCircleOutlined ref={ref3}
            onClick={() => {
              trackEvent("landing_page_tour_button_clicked", {});
              setOpenTour(true);
            }}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="col-12 mx-2">
          <Typography className="text-midgrey poppins-regular">
            Build Something Amazing Today!
          </Typography>
        </Col>
      </Row>
      <Divider style={{backgroundColor:"#D7BEF7"}} />

      {/* For Mobile screens */}
      <div style={{ overflowX: 'auto' }} className="mobile-card-scrollbar">
        <Row xs={24} className="d-sm-none" style={{ flexFlow: 'row' }}>
          {global_var.role_id !== global_var.STUDENT_ROLE_ID && (
              <Card
                className="glass specific-card top-card-container"
                actions={[
                  <Link style={{textDecoration:'none'}}
                    to={"/evaluateprojects/"}
                    onClick={() => {
                      trackEvent("landing_page_evaluate_button_clicked", {});
                    }}
                  >
                <Typography style={{color:'#E96358'}} className="d-inline">
                    View all {'>'}
                </Typography>
                  </Link>,
                ]}
              >
                <Meta
                  avatar={
                    <img alt="evaluate icon" src={EvaluateIcon}></img>
                  }
                  title={
                    <Typography style={{color:'#2E3876'}}>
                      Evaluate Projects
                    </Typography>
                  }
                  description={
                    <Typography.Paragraph className="poppins-regular text-midgrey" style={{fontSize:'12px'}}>
                      You can evaluate all the projects submitted by students here.
                    </Typography.Paragraph>
                  }
                />
              </Card>
          )}
            <Card
              className="glass specific-card top-card-container"
              actions={[
                <Link style={{textDecoration:'none'}}
                  to={"/portfolio/"}
                  onClick={() => {
                    trackEvent("landing_page_portfolio_button_clicked", {});
                  }}
                > 
                <Typography style={{color:'#E96358'}} className="d-inline">
                    View all {'>'}
                </Typography>
                </Link>,
              ]}
            >
              <Meta
                avatar={
                  <img alt="portfolio icon" src={PortfolioIcon}></img>
                }
                title={
                  <Typography style={{color:'#2E3876'}}>{
                    global_var.role_id === global_var.STUDENT_ROLE_ID
                      ? "My Portfolio"
                      : "Student Portfolio"
                    }
                  </Typography>
                }

                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey" style={{fontSize:'12px'}}>
                    {global_var.role_id === global_var.STUDENT_ROLE_ID
                      ? "You can see all your projects added to portfolio"
                      : "You can see all the projects which are added to portfolio by students."}
                  </Typography.Paragraph>
                }
              />
            </Card>
            <Card
              className="glass specific-card top-card-container"
              actions={[
                <Link style={{textDecoration:'none'}}
                to={global_var.role_id === global_var.STUDENT_ROLE_ID ? "/labquestionview/" : "/assignments/"}
                  onClick={() => {
                    trackEvent("landing_page_lab_asssignment_button_clicked", {});
                  }}
                >
                <Typography style={{color:'#E96358'}} className="d-inline">
                    View all {'>'}
                </Typography>
                </Link>,
              ]}
            >
              <Meta
                avatar={
                  <img alt="lab assignment icon" src={LabAssignmentIcon}></img>
                }
                title={
                  <Typography style={{color:'#2E3876'}}>
                    Lab Assignment
                  </Typography>
                  }
                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey" style={{fontSize:'12px'}}>
                    {global_var.role_id === global_var.STUDENT_ROLE_ID
                    ? 'You can see all assignments assigned to you.'
                    :' You can see all lab assignments submitted by students here.'}
                  </Typography.Paragraph> 
                }
              />
            </Card>
          {(global_var.role_id === global_var.SUPERADMIN_ROLE_ID || global_var.role_id === global_var.ADMIN_ROLE_ID) && (
              <Card className="glass specific-card top-card-container" actions={[
                <Link to={"/managecslabmenu"} style={{textDecoration:'none'}}>
                  <Typography style={{color:'#E96358'}} className="d-inline">
                    Manage {'>'}
                  </Typography>
                </Link>,
              ]}>
                <Meta
                  avatar={
                    <img alt="manage menu icon" src={ManageMenuIcon}></img>
                  }
                  title="Manage CS Lab Menu"
                  description={
                    <Typography.Paragraph className="poppins-regular text-midgrey" style={{fontSize:'12px'}}>
                        You can assign grade-wise menus for each company.
                    </Typography.Paragraph>
                  }
                />
              </Card>
          )}
        </Row>
      </div>

    {/* Desktop Screens */}
      <Row gutter={[10, 10]}  style={{ flexWrap: 'wrap' ,marginLeft:'10px'}} >
          {global_var.role_id !== global_var.STUDENT_ROLE_ID && (
          <Col xs={24} sm={12} md={8} lg={5} xl={5} className="d-none d-md-block">
            <Card
              className="glass poppins-regular specific-card"
              actions={[
                <Link style={{textDecoration:'none'}}
                  to={"/evaluateprojects/"}
                  onClick={() => {
                    trackEvent("landing_page_evaluate_button_clicked", {});
                  }}
                >
              <Typography style={{color:'#E96358' ,paddingRight:'10px'}} align="right">
                  View all
                  <img alt="vector icon" style={{height: 15,width: 15,paddingLeft:'5px'}} src={VectorIcon}></img>
              </Typography>
                </Link>,
              ]}
            >
              <Row style={{marginBottom:'5px', alignItems:'center',justifyContent: 'space-between' }}>
                <Col>
                  <img alt="evaluate icon" style={{ height: 30, width: 30 }} src={EvaluateIcon}/>
                </Col>
                {pendingEvaluationCount > 0 && (
                  <Col>
                    <span
                      style={{
                        backgroundColor: '#E96358',
                        color: 'white',
                        borderRadius: '12px',
                        padding: '2px 6px',
                        fontSize: '10px',
                        fontWeight: 600,
                        display: 'inline-block',
                        textAlign: 'center',
                      }}
                    >
                      {pendingEvaluationCount}
                    </span>
                  </Col>
                )}
              </Row>
              <Meta
                title={
                  <Typography className="poppins-regular midnight-blue mb-0">
                    Evaluate Projects
                  </Typography>
                }
                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey mb-0" style={{fontSize:'12px'}}>
                    You can evaluate all the projects submitted by students here.
                  </Typography.Paragraph>
                }
              />
            </Card>
          </Col>
          )}
          <Col  xs={24} sm={12} md={8} lg={5} xl={5} className="d-none d-md-block">
            <Card
              className="glass specific-card"
              actions={[
                <Link style={{textDecoration:'none'}}
                to={global_var.role_id === global_var.STUDENT_ROLE_ID ? "/labquestionview/" : "/assignments/"}
                  onClick={() => {
                    trackEvent("landing_page_lab_asssignment_button_clicked", {});
                  }}
                >

                <Typography style={{color:'#E96358',paddingRight:'10px'}} align="right">
                    View all 
                    <img alt="vector icon" style={{height: 15,width: 15,paddingLeft:'5px'}} src={VectorIcon}></img>
                </Typography>
                </Link>,
              ]}
            >
              <Row style={{marginBottom:'5px', alignItems:'center',justifyContent: 'space-between' }}>
                <Col>
                  <img alt="lab assignment icon" style={{height: 30,width: 30}} src={LabAssignmentIcon}/>
                </Col>
                {(notStartedAssignmentCount > 0 || submittedAssignmentCount > 0) && (
                  <Col>
                    <span
                      style={{
                        backgroundColor: '#E96358',
                        color: 'white',
                        borderRadius: '12px',
                        padding: '2px 6px',
                        fontSize: '10px',
                        fontWeight: 600,
                        display: 'inline-block',
                        textAlign: 'center',
                      }}
                    >
                            {global_var.role_id === global_var.STUDENT_ROLE_ID ? notStartedAssignmentCount : submittedAssignmentCount}
                    </span>
                  </Col>
                )}
              </Row>
              <Meta
                title={
                  <Typography className="poppins-regular midnight-blue mb-0">
                    Lab Assignment
                  </Typography>
                  }
                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey mb-0" style={{fontSize:'12px'}}>
                    {global_var.role_id === global_var.STUDENT_ROLE_ID
                    ? 'You can see all assignments assigned to you.'
                    :' You can see all lab assignments submitted by students here.'}
                  </Typography.Paragraph> 
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={5} xl={5} className="d-none d-md-block" >
            <Card
              className="glass specific-card poppins-regular"
              actions={[
                <Link style={{textDecoration:'none'}}
                  to={"/portfolio/"}
                  onClick={() => {
                    trackEvent("landing_page_portfolio_button_clicked", {});
                  }}
                > 
                <Typography style={{color:'#E96358',paddingRight:'10px'}} align="right">
                    View all 
                    <img alt="vector icon" style={{height: 15,width: 15,paddingLeft:'5px'}} src={VectorIcon}></img>
                </Typography>
                </Link>,
              ]}
            >
              <Row style={{marginBottom:'5px'}}>
                <img alt="portfolio icon" style={{height: 30,width: 30}} src={PortfolioIcon}></img>
              </Row>
              <Meta
                title={
                  <Typography className="poppins-regular midnight-blue mb-0">{
                    global_var.role_id === global_var.STUDENT_ROLE_ID
                      ? "My Portfolio"
                      : "Student Portfolio"
                    }
                  </Typography>
                }

                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey mb-0" style={{fontSize:'12px' }}>
                    {global_var.role_id === global_var.STUDENT_ROLE_ID
                      ? "You can see all your projects added to portfolio"
                      : "You can see all the projects which are added to portfolio by students."}
                  </Typography.Paragraph>
                }
              />
            </Card>
          </Col>
          {(global_var.role_id === global_var.SUPERADMIN_ROLE_ID || global_var.role_id === global_var.ADMIN_ROLE_ID) && (
          <Col xs={24} sm={12} md={8} lg={5} xl={5} className="d-none d-md-block" >
            <Card className="glass specific-card" 
            actions={[
              <Link to={"/managecslabmenu"} style={{textDecoration:'none'}}>
                <Typography style={{color:'#E96358',paddingRight:'10px'}} align="right">
                  Manage 
                  <img alt="vector icon" style={{height: 15,width: 15,paddingLeft:'5px'}} src={VectorIcon}></img>
                </Typography>
              </Link>,
            ]}>
              <Row style={{marginBottom:'5px'}}>
                <img alt="manage menu icon" style={{height: 30,width: 30}} src={ManageMenuIcon}></img>

              </Row>
              <Meta
                title={
                  <Typography className="poppins-regular midnight-blue mb-0" style={{fontWeight:'200px'}}>
                    Manage CS Lab Menu
                  </Typography>
                }
                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey mb-0" style={{fontSize:'12px'}}>
                      You can assign grade-wise menus for each company.
                  </Typography.Paragraph>
                }
              />
            </Card>
          </Col>
          )}
          {(global_var.role_id === global_var.SUPERADMIN_ROLE_ID || global_var.role_id === global_var.ADMIN_ROLE_ID) && (
          <Col xs={24} sm={12} md={8} lg={4} xl={4} className="d-none d-md-block" >
            <Card className="glass specific-card" 
            actions={[
              <Link to={"/manageaifeatures"} style={{textDecoration:'none'}}>
                <Typography style={{color:'#E96358',paddingRight:'10px'}} align="right">
                  Manage 
                  <img alt="vector icon" style={{height: 15,width: 15,paddingLeft:'5px'}} src={VectorIcon}></img>
                </Typography>
              </Link>,
            ]}>
              <Row style={{marginBottom:'5px'}}>
                  <img alt="chat ai icon" style={{height: 30,width: 30}} src={ChatAiIconBlack}></img>
              </Row>
              <Meta
                title={
                  <Typography className="poppins-regular midnight-blue mb-0" style={{fontWeight:'200px'}}>
                    Manage Ai features
                  </Typography>
                }
                description={
                  <Typography.Paragraph className="poppins-regular text-midgrey mb-0" style={{fontSize:'12px'}}>
                    You can enable/disable ai features for students.
                  </Typography.Paragraph>
                }
              />
            </Card>
          </Col>
          )}
      </Row>
      <Row style={{marginTop:'20px'}}>
        <Col className="col-12 col-md-9" >
          <Row justify="space-evenly" className="container" align="middle">
            <Col justify="space-evenly" className="d-none d-sm-block">
              {projectStacks && Object.keys(projectStacks).map((topKey, topIndex) => (
              <Col key={topKey} className="mb-3 mt-3 poppins-regular midnight-blue" style={{fontSize:'18px'}}>
                  {topKey}
                  
                <List
                  grid={{
                    gutter: 24,
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 3,
                    xl: 3,
                    xxl: 3,
                  }}
                  dataSource={projectStacks[topKey]}
                  renderItem={(projectStack, index) => (
                    <List.Item className="mt-3">
                      <Card
                      cover={
                        <div className="p-3 m-3 text-center" 
                          style={{backgroundColor:getIdeProjectTypeMetaData(projectStack.projectStackName).coverColor,
                          alignItems: 'center', borderRadius:'10px',maxWidth:'90%'}}>
                          <Avatar
                            size={{
                              xs: 24,
                              sm: 32,
                              md: 40,
                              lg: 64,
                              xl: 80,
                              xxl: 100,
                            }}
                            src={getIdeProjectLogo(
                              projectStack.projectStackName
                            )}
                          />
                        </div>
                      }
                        className="glass new-card"
                        actions={setActions(
                          projectStack.projectStackName,
                          index,
                          topIndex
                        )}
                      >
                        <Meta
                          title={
                            <span
                              className="poppins-regular"
                              style={{ display: "flex", alignItems: "center", gap: 8 }}
                            >
                              {getIdeProjectTypeMetaData(
                                projectStack.projectStackName
                              ).projectStackDisplayName}

                              {getIdeProjectTypeMetaData(projectStack.projectStackName).beta && (
                                <span
                                  style={{
                                    fontSize: 10,
                                    padding: "2px 6px",
                                    borderRadius: 8,
                                    backgroundColor: "#fde3cf",
                                    color: "#d46b08",
                                    textTransform: "uppercase",
                                    fontWeight: 600,
                                  }}
                                >
                                  Beta
                                </span>
                              )}
                            </span>
                          }
                          description={
                            <Typography.Paragraph
                              className="text-midgrey poppins-regular"
                              style={{ fontSize: "12px" }}
                              ellipsis={{
                                tooltip: getIdeProjectTypeMetaData(
                                  projectStack.projectStackName
                                ).description,
                                rows: 2,
                              }}
                            >
                              {getIdeProjectTypeMetaData(
                                projectStack.projectStackName
                              ).description}
                            </Typography.Paragraph>
                          }
                        />
                      </Card>
                    </List.Item>
                  )}
                ></List>
                <Divider orientation="left"  style={{backgroundColor:'#D7BEF7'}}></Divider>
              </Col>
              ))}
            </Col>
            
            {/* Desktop view */}
            <Col justify="center" className="d-block d-md-none">
              {projectStacks &&
                Object.keys(projectStacks).map((topKey, topIndex) => (
                  <div key={topKey} className="mb-3 mt-3 p-3 rounded-3" style={{backgroundColor:'#ffffff'}} >
                    <Typography style={{ color: '#2E3876', fontSize: '18px' }}>{topKey}</Typography>
                    <div className="card-container mt-2">
                      {projectStacks[topKey].map((projectStack, index) => (
                        
                        <Card
                          key={index}
                          className="glass new-card mobile-card"
                          actions={setActions(projectStack.projectStackName, index, topIndex)}
                        >
                          <Meta
                            avatar={ 
                              <div style={{ backgroundColor: getIdeProjectTypeMetaData(projectStack.projectStackName).coverColor, padding: '10px', borderRadius: '30%',marginTop:'10px'}}>
                            <Avatar
                              size={{
                                xs: 40,
                                sm: 36,
                                md: 40,
                                lg: 64,
                                xl: 80,
                                xxl: 100,
                              }}
                              src={getIdeProjectLogo(projectStack.projectStackName)}
                            />
                            </div>
                          }
                            title={
                              <span
                                className="poppins-regular"
                                style={{ display: "flex", alignItems: "center", gap: 8 }}
                              >
                                {getIdeProjectTypeMetaData(projectStack.projectStackName).projectStackDisplayName}

                                {getIdeProjectTypeMetaData(projectStack.projectStackName).beta && (
                                  <span
                                    style={{
                                      fontSize: 10,
                                      padding: "2px 6px",
                                      borderRadius: 8,
                                      backgroundColor: "#fde3cf",
                                      color: "#d46b08",
                                      textTransform: "uppercase",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Beta
                                  </span>
                                )}
                              </span>
                            }
                            description={
                              <Typography.Paragraph
                                className="text-midgrey poppins-regular"
                                style={{ fontSize: "12px" }}
                                ellipsis={{ tooltip: getIdeProjectTypeMetaData(projectStack.projectStackName).description, rows: 2 }}
                              >
                                {getIdeProjectTypeMetaData(projectStack.projectStackName).description}
                              </Typography.Paragraph>
                            }
                          />
                        </Card>
                      ))}
                    </div>
                  </div>
                ))}
            </Col>
          </Row>

          <Tour placement="rightTop"
          className="glass"
          open={openTour}
          onClose={() => setOpenTour(false)}
          steps={steps}
          />   
        </Col>
        
        <Col className="col-3 d-none d-md-block">
          {tip ? (
            <Col className="bannerGlass mt-2 d-none d-md-block">
              <Card className="radius bg-transparent border-0" bordered={false}>
                <div className="col-12">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-xs-12" >
                      <div className="col-12 ">
                        <Typography className="mb-2 d-flex align-items-center poppins-regular midnight-blue">
                          <QuickTipIcon className="mr-2 "/> Quick Tips!
                        </Typography>
                        <br />
                        <ReactMarkdown className="poppins-regular text-midgrey" style={{fontSize:'11px'}} children={tip || <Skeleton />} />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ) : (
            <Col className="bannerGlass mt-2 d-none d-md-block">
              <Card className="radius bg-transparent border-0" bordered={false}>
                <div className="col-12">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-xs-12">
                      <div className="col-12 ">
                        <Typography className="mb-2 d-flex align-items-center poppins-regular midnight-blue">
                          <QuickTipIcon className="mr-2" /> Quick Tips
                        </Typography>
                        <br />
                        <Skeleton active="true" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          )}   
        </Col>
      </Row>
    </>
  );
};

export default Home;
